import React, { useState } from 'react';
import { Select, Badge } from '../ui-kit';

const ColorSelector = props => {
  // Bootstrap colors. See also HasColor concern
  const colorOptions = [
    { name: 'blue', hex: '#0d6efd' },
    { name: 'indigo', hex: '#6610f2' },
    { name: 'purple', hex: '#6f42c1' },
    { name: 'pink', hex: '#d63384' },
    { name: 'red', hex: '#dc3545' },
    { name: 'orange', hex: '#fd7e14' },
    { name: 'yellow', hex: '#ffc107' },
    { name: 'green', hex: '#198754' },
    { name: 'teal', hex: '#20c997' },
    { name: 'cyan', hex: '#0dcaf0' },
    { name: 'gray', hex: '#6c757d' },
    { name: 'dark-gray', hex: '#343a40' },
    { name: 'dark', hex: '#212529' },
    { name: 'light', hex: '#f8f9fa' }
  ];

  // if a color is selected, use that, otherwise default to the first color
  const [selectedColor, setSelectedColor] = useState(props.selectedColor || colorOptions[0].hex);

  const handleChange = events => {
    if (!Array.isArray(events)) events = [events].filter(Boolean);
    const values = events.map(e => e.value);
    setSelectedColor(values[0]);
  };

  // if the currently selected color isn't part of the list, create a custom
  // option so the color isn't blanked out
  if (!colorOptions.some(e => e.hex === selectedColor)) {
    colorOptions.push({ name: 'custom', hex: selectedColor });
  }

  const options = colorOptions.map(c => {
    const textLabel = c.name;
    const label = (
      <div>
        <Badge color={c.hex}> {c.name} </Badge>
      </div>
    );
    return { value: c.hex, textLabel, label };
  });

  const selectedOption = options.filter(o => selectedColor === o.value);

  return (
    <>
      <input type="hidden" name={props.inputName} value={selectedColor} />
      <Select
        style={{ zIndex: '9999', width: '60px' }}
        value={selectedOption}
        onChange={handleChange}
        options={options}
        isClearable={false}
        isSearchable={false}
        className="react-select"
      />
    </>
  );
};

export default ColorSelector;
